import { setStorageAdapter } from "@eventify/shared/config/storageAdapter";
import type { StateStorage } from "zustand/middleware";

const webStorage: StateStorage = {
  getItem: (key: string) => {
    if (typeof window === "undefined") return null;
    return localStorage.getItem(key);
  },
  setItem: (key: string, value: string) => {
    if (typeof window === "undefined") return;
    localStorage.setItem(key, value);
  },
  removeItem: (key: string) => {
    if (typeof window === "undefined") return;
    localStorage.removeItem(key);
  },
};

setStorageAdapter(webStorage);
